import React, { ReactElement, PropsWithChildren, SetStateAction, Dispatch } from 'react';

export const BlocksContext = React.createContext<IBlocksProviderProps['value'] | null>(null);

interface IBlocksProviderProps {
  value: {
    blocks: IBlock[];
    setBlocks: Dispatch<SetStateAction<IBlock[]>>;
    unsavedBlocks: IBlock[];
    setUnsavedBlocks: Dispatch<SetStateAction<IBlock[]>>;
    siteDomain: string;
    dynamicFieldsList: string;
    dynamicFieldsPermission: boolean;
  }
}

export default function BlocksProvider({ children, value }: PropsWithChildren<IBlocksProviderProps>): ReactElement {
  return (
    <BlocksContext.Provider value={value}>
      {children}
    </BlocksContext.Provider>
  );
}
